// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/All-Products/Longy.png";
import thumb1 from "../assets/images/All-Products/Longy.png";
import thumb2 from "../assets/images/All-Products/Longy.png";
import thumb3 from "../assets/images/All-Products/Longy.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("side_effects");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Longy </h2>
              <p className="sub-heading text-muted">LEVOCETIRIZINE HYDROCHLORIDE TABLETS</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>Longy 5mg tablet is potent, effective and long-lasting antihistamine having long control over allergy.</li>
                  <li>Longy 5mg tablet blocks cutaneous response to histamines, making it effective in treating allergies associated with urticaria.</li>
                  <li>Longy 5mg tablets can effectively treat skin itching and hives.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Longy?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["side_effects", "disease-overview", "application", "dosage"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "disease-overview"
                    ? "DISEASE OVERVIEW"
                    : tab === "side_effects"
                      ? "SIDE EFFECTS"
                      : tab === "application"
                        ? "APPLICATION GUIDELINES"
                        : tab === "dosage"
                          ? "DOSAGE"
                          : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "disease-overview" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li><strong>Chronic idiopathic urticaria (CIU):</strong> A form of chronic hive that results in itchy, red bumps or wheals on the skin. People with CIU usually have flares that come and go for several years.</li>

                    <li><strong>Rash:</strong> An area of irritated or swollen skin. Many rashes are itchy, red, painful, and irritated. Some may lead to blisters or patches of raw skin. Rashes can be caused by various medical conditions, irritating substances, or allergies.</li>

                    <li><strong>Hives:</strong> A common skin rash triggered by factors such as certain foods, medication, and stress.</li>

                    <li><strong>Symptoms:</strong> Itchy, raised, red or skin-coloured welts on the skin’s surface.</li>
                  </ul>

                </div>
              )}
              {activeTab === "side_effects" && (
                <div className="tab-content fade-in">

                  <ul>
                    <li><strong>Severe:</strong>
                      <ul>
                        <li>Sleepiness</li>
                        <li>Headache</li>
                        <li>Runny nose and cough</li>
                        <li>Blurred vision</li>
                      </ul>
                    </li>

                    <li><strong>Common / Mild:</strong>
                      <ul>
                        <li>Dry mouth</li>
                        <li>Diarrhoea</li>
                        <li>Nausea or vomiting</li>
                      </ul>
                    </li>

                    <li><strong>Rare:</strong>
                      <ul>
                        <li>Difficulty in passing urine</li>
                      </ul>
                    </li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Take Longy 5 mg tablet with or without food</li>
                      <li>Do not take in larger amounts than advised/prescribed</li>
                      <li>Consult the doctor if you experience any undesirable side effects</li>
                      <li>Ensure that the course of treatment is completed</li>
                      <li>Do not stop the use of this medicine without consulting your doctor</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "dosage" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Adults and Adolescents:</strong> 5 mg/day</li>
                      <li><strong>Pediatric (0–11 years old):</strong> 2.5 mg/day</li>
                      <li><strong>Missed Dose:</strong> Take the missed dose as soon as you remember. If it is almost time for the next scheduled dose, then the missed dose can be skipped. Do not use extra medicine to make up for the missed dose.</li>
                      <li><strong>Overdose:</strong> Seek emergency medical treatment or contact the doctor in case of an overdose.</li>
                    </ul>



                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
